import React from 'react';
import { Bar } from 'react-chartjs-2';
import { toTitleCase } from '../util/titleCase';

require ('./RoundedBars.js')

const resultData = [
    { subject: 'Mathematics', score: 75 },
    { subject: 'Business Studies', score: 65 },
    { subject: 'French', score: 40 },
    { subject: 'English', score: 70 },
    { subject: 'Yoruba', score: 90 },
    { subject: 'Agriculture', score: 80 }
]

const BarChart = ({ data }) => {

    const chartLabels = data.map(result => toTitleCase(result.name));
    const chartValues = data.map(result => result.score);
    const barColors = data.map(result => result.progresscolor);

    // typeof(chartLabels);

    const chartData = () => {
        return {
            labels: chartLabels,
            datasets: [
                {
                    label: 'Score',
                    borderColor: '#3182ce',
                    data: chartValues,
                    backgroundColor: barColors
                    // backgroundColor: [
                    //     '#5FBE90',
                    //     '#70B9F3',
                    //     '#DB695F',
                    //     '#EE8727',
                    //     '#EDA80A',
                    //     '#B8DCF9',
                    // ],
                    // borderWidth: 1,
                }
            ]
        }
    };

    const options = {
        cornerRadius: 8,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              }, 
              
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              }
            },
          ],
        },
    }

    return (
      <>
        <div className='hidden w-full sm:block'>
          <Bar
            height={120}
            width={200}
            data={chartData}
            options={options}
          />
        </div>
        <div className='block sm:hidden'>
          <Bar
            height={220}
            width={200}
            data={chartData}
            options={options}
          />
        </div>
      </>
    )
};

export default BarChart;